const _entities = [
    {
      id: 1,
      internalId: 1,
      name: 'Lange Wapper',
      slogan: '#tofstebendevantstad',
      fragment: 'lange-wapper',
      startingAge: 6,
      whenShort: [ 'zo' ],
      whenLong: [
        {
          day: 'Zondag',
          timeSpan: '9u45 - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Beatrijslaan 41, 2050 Linkeroever',
          addressLine: 'Beatrijslaan 41',
          city: 'Linkeroever',
          postcode: '2050'
        }
      ],
      website: 'https://www.langewapper.be/',
      district: 'Linkeroever',
      contact: 'master@langewapper.be',
      money: '€72'
    },
    {
      id: 2,
      internalId: 17,
      name: 'Prins Albert',
      slogan: 'Technisch en authentiek en avontuurlijk',
      fragment: 'prins-albert',
      startingAge: 5,
      whenShort: [ 'za' ],
      whenLong: [
        {
          day: 'Zaterdag',
          timeSpan: '11u - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Park Groot Schijn August van de Wielelei 2100 Deurne',
          addressLine: 'Beatrijslaan 41',
          city: 'Deurne',
          postcode: '2100'
        }
      ],
      website: 'http://www.17bsb.be/',
      district: 'Deurne',
      contact: 'info@17bsb.be',
      money: '€50'
    },
    {
      id: 3,
      internalId: 45,
      name: 'De Schrans',
      fragment: 'de-schrans',
      startingAge: 5,
      slogan: 'Klein maar fijn',
      whenShort: [ 'zo' ],
      whenLong: [
        {
          day: 'Zondag',
          timeSpan: '14u - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Lesseliersdreef, 9120 Beveren',
          addressLine: 'Lesseliersdreef',
          city: 'Beveren',
          postcode: '9120'
        }
      ],
      website: 'http://www.fosdeschrans.be/',
      district: 'Beveren',
      contact: 'eenheidsleiding@fosdeschrans.be',
      money: '€40'
    },
    {
      id: 4,
      internalId: 80,
      name: 'Kludde',
      slogan: 'Wateravontuur en waterpret',
      fragment: 'kludde',
      startingAge: 5,
      whenShort: [ 'zo' ],
      whenLong: [
        {
          day: 'Zondag',
          timeSpan: '10u - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Derde Weg 3, 2040 Zandvliet',
          addressLine: 'Derde Weg 3',
          city: 'Zandvliet',
          postcode: '2040'
        }
      ],
      website: 'http://www.seascoutskludde.be/',
      district: 'Zandvliet',
      contact: 'marijke.janssens@telenet.be',
      money: '€60'
    },
    {
      id: 5,
      internalId: 205,
      name: 'Impeesa',
      fragment: 'impeesa',
      startingAge: 5,
      whenShort: [ 'zo' ],
      whenLong: [
        {
          day: 'Zondag',
          timeSpan: '10u - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Peter Benoitlaan 31, 2100 Deurne',
          addressLine: 'Peter Benoitlaan 31',
          city: 'Deurne',
          postcode: '2100'
        }
      ],
      website: 'http://www.impeesa.be/',
      district: 'Deurne',
      contact: 'ehl@impeesa.be',
      money: '€52'
    },
    {
      id: 6,
      internalId: 233,
      name: 'Durendael',
      slogan: 'Speels en open',
      fragment: 'durendael',
      startingAge: 5,
      whenShort: [ 'zo' ],
      whenLong: [
        {
          day: 'Zondag',
          timeSpan: '14u - 17u'
        }
      ],
      addresses: [
        {
          id: 1,
          address: 'Maasfortbaan 23, 2500 Lier',
          addressLine: 'Maasfortbaan 23',
          city: 'Lier',
          postcode: '2500'
        }
      ],
      website: 'http://www.durendael.be/nl/',
      district: 'Lier',
      contact: 'eenheidsleiding@scoutslier.be',
      money: '€40'
    },
  ]

  export default {
    getEntities (cb) {
      setTimeout(() => cb(_entities), 1)
    }
  }



// WEBPACK FOOTER //
// ./src/api/entities.js